import { useSelector } from 'react-redux';
import { CreditCard, HelpOutline, Home, Speed } from '@vst/beam-icons/icons';
import { useTranslation } from 'react-i18next';

import { selectHasWirelessInternet } from '@app/redux';

import TabBar from './TabBar';

const MobileTabBar = (): JSX.Element => {
  const { t } = useTranslation('Nav');
  const isFixedWirelessUser = useSelector(selectHasWirelessInternet);

  const overview = {
    label: t('Overview'),
    path: '/',
    testId: 'Overview',
    icon: Home,
  };

  const billing = {
    label: t('BillPay'),
    path: '/PayBill',
    testId: 'PayBill',
    icon: CreditCard,
  };

  const usage = {
    label: t('Plan'),
    path: '/PlanUsage',
    testId: 'PlanUsage',
    icon: Speed,
  };

  const help = {
    label: t('Help'),
    path: '/Network',
    testId: 'Network',
    icon: HelpOutline,
  };

  const defaultNavItems = [overview, billing, usage, help];
  const fixedWirelessNavItems = [overview, billing];
  const navItems = isFixedWirelessUser ? fixedWirelessNavItems : defaultNavItems;

  return <TabBar navItems={navItems} />;
};

export default MobileTabBar;
